import React from "react";
import PropTypes from "prop-types";
import schemaPlace from "../../utils/schemaPlace";
import schemaPriceRange from "../../utils/schemaPriceRange";
import schemaDescription from "../../utils/schemaDescription";
import schemaType from "../../utils/schemaType";
import { poiTypes } from "../../../../../server/lib/open-planet/poiTypes";

const markup = htmlContent => ({ __html: htmlContent });

const ReviewSchema = ({ poi }) => {
  const {
    address,
    containingPlace: place,
    id,
    images = [],
    name,
    priceRange,
    publishedAt: datePublished,
    review,
    slug,
    subtypes,
    telephone,
    website,
  } = poi;

  const poiType = (poi.poiType.toLowerCase() === "restaurants") ?
    "eating" :
    poi.poiType.toLowerCase();
  const poiImages = images.length ? images[0].path : "";

  const typeOfSchema = schemaType(poiType, subtypes) || poiTypes[poiType].schemaType || "Place";
  const places = place ? schemaPlace(place) : {};
  const schemaImage = poiImages;
  const hasCoordinates = place &&
    place.center &&
    place.center.coordinates.length === 2;
  const hasCuisine = poiType === poiTypes.eating.name && typeOfSchema !== "GroceryStore";

  const schema = {
    "@context": "http://schema.org",
    "@type": typeOfSchema,
    "@id": website || id,
    name,
    image: schemaImage || `https://s3.amazonaws.com/static-asset/poi-type-${poiType}.png`,
    priceRange: schemaPriceRange(priceRange),
    address: {
      "@type": "PostalAddress",
      streetAddress: address.street,
      addressLocality: places.city,
      postalCode: "",
      addressRegion: places.region,
      addressCountry: places.country,
    },
    telephone: (telephone && telephone.national) ? telephone.national : "",
    review: {
      "@type": "Review",
      url: slug ? `https://www.lonelyplanet.com/${slug}` : "",
      author: {
        "@type": "Organization",
        name: "Lonely Planet",
        sameAs: "https://www.lonelyplanet.com",
      },
      publisher: {
        "@type": "Organization",
        name: "Lonely Planet",
        sameAs: "https://www.lonelyplanet.com",
      },
      datePublished: datePublished || "",
      description: (review && review.essential) ? schemaDescription(review.essential, poiType) : "",
      inLanguage: "en",
    },
  };

  if (website) {
    schema.sameAs = website;
  }

  if (hasCoordinates) {
    schema.geo = {
      "@type": "GeoCoordinates",
      latitude: place.center.coordinates[1],
      longitude: place.center.coordinates[0],
    };
  }

  if (hasCuisine && subtypes && subtypes.length) {
    schema.servesCuisine = subtypes.join(", ");
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={markup(JSON.stringify(schema))}
    />
  );
};

ReviewSchema.propTypes = {
  poi: PropTypes.shape({
    address: PropTypes.shape({
      street: PropTypes.string,
    }),
    containingPlace: PropTypes.shape({
      ancestry: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        placeType: PropTypes.string,
      })),
      name: PropTypes.string,
      placeType: PropTypes.string,
    }),
    imageAssociations: PropTypes.object,
    name: PropTypes.string,
    poiType: PropTypes.string,
    priceRange: PropTypes.string,
    publishedAt: PropTypes.string,
    review: PropTypes.shape({
      essential: PropTypes.string,
    }),
    slug: PropTypes.string,
    subtypes: PropTypes.arrayOf(PropTypes.string),
    telephone: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object,
    ]),
    website: PropTypes.string,
  }).isRequired,
};

export default ReviewSchema;



// WEBPACK FOOTER //
// ./assets/pois/components/schema/schemaReview.jsx